import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  ITEM_FOOTER_CLASS,
  TItemFooterProps,
} from "@/ui/components/data-display/Item/Item.config";

export const ItemFooter: FC<TItemFooterProps> = (
  {
    className,
    children,
    ...props
  },
) => (
  <div
    {...props}
    data-component="ItemFooter"
    className={cn(ITEM_FOOTER_CLASS, className)}
  >
    { children }
  </div>
);

ItemFooter.displayName = "ItemFooter";
